import { render, staticRenderFns } from "./GuruList.vue?vue&type=template&id=5ef9afc3&scoped=true"
import script from "./GuruList.vue?vue&type=script&lang=js"
export * from "./GuruList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9afc3",
  null
  
)

export default component.exports